<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />

    <el-tabs v-model="tabName" type="card" style="margin-top: 20px;">
      <el-tab-pane label="状态式探测器" name="second">
        <div class="search-line">
          <div class="btn-box">
            <button-add :pathName="addDataParkHonor2" v-if="permissionCodes.indexOf('033005001') !== -1"/>
            <!--<button-delete @deleteSelection="deleteSelection" />-->
          </div>
          <input-select selectTitle="设备类型" :selectKey="'deviceType'" selectWidth="180px" :selectData="deviceTypeList2" @search="search" style="margin-right: 10px;"/>
          <input-search placeholder="设备名称/设备编号" @search="searchKey" />
        </div>
        <table-main :selection="false" :tableHead="tableHead2" :tableData="tableData" @deleteLine="deleteLine" :deleteTipInfo="'是否确认删除该数据？'" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :operationArr="operationArr" @changePagination="changePagination" />
      </el-tab-pane>

      <el-tab-pane label="触发式探测器" name="third">
        <div class="search-line">
          <div class="btn-box">
            <button-add :pathName="addDataParkHonor3" v-if="permissionCodes.indexOf('033005001') !== -1"/>
            <!--<button-delete @deleteSelection="deleteSelection" />-->
          </div>
          <input-select selectTitle="设备类型" :selectKey="'deviceType'" selectWidth="180px" :selectData="deviceTypeList3" @search="search" style="margin-right: 10px;"/>
          <input-search placeholder="设备名称/设备编号" @search="searchKey" />
        </div>
        <table-main :selection="false" :tableHead="tableHead3" :tableData="tableData" @deleteLine="deleteLine" :deleteTipInfo="'是否确认删除该数据？'" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :operationArr="operationArr" @changePagination="changePagination" />
      </el-tab-pane>

      <el-tab-pane label="配电探测器" name="first">
        <div class="search-line">
          <div class="btn-box">
            <button-add :pathName="addDataParkHonor" v-if="permissionCodes.indexOf('033005001') !== -1"/>
          </div>
          <input-select selectTitle="设备类型" :selectKey="'deviceType'" selectWidth="180px" :selectData="deviceTypeList" @search="search" style="margin-right: 10px;"/>
          <input-search placeholder="设备名称/设备编号" @search="searchKey" />
        </div>
        <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @deleteLine="deleteLine" :deleteTipInfo="'是否确认删除该数据？'" @goToModifyPage="goToModifyPage2" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :operationArr="operationArr" @changePagination="changePagination" />
      </el-tab-pane>

      <el-tab-pane label="泵探测器" name="fourth">
        <div class="search-line">
          <div class="btn-box">
            <button-add :pathName="addDataParkHonor4" v-if="permissionCodes.indexOf('033005001') !== -1"/>
            <!--<button-delete @deleteSelection="deleteSelection" />-->
          </div>
          <input-search placeholder="设备名称/设备编号" @search="searchKey" />
        </div>
        <table-main :selection="false" :tableHead="tableHead4" :tableData="tableData" @deleteLine="deleteLine" :deleteTipInfo="'是否确认删除该数据？'" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :operationArr="operationArr" @changePagination="changePagination" />
      </el-tab-pane>
    </el-tabs>


  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/SmartDetection";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nError, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "smart-detection-power-distribution-cabinet-manage",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "配电监测",
          name: "smart-detection-over-view"
        },
        {
          value: "传感器管理"
        }
      ],
      tabName: 'second',
      addDataParkHonor: "smart-detection-power-distribution-cabinet-add",
      operationArr: ["modify", "delete"],

      deviceTypeList: [
        { key: "", label: "全部" },
        { key: "P0", label: "状态采集器" },
        { key: "P1", label: "电压采集器" },
        { key: "P2", label: "温度采集器" }
      ],

      tableHead: [
        {
          prop: "deviceName",
          label: "设备名称"
        },
        {
          prop: "deviceCode",
          label: "设备编号"
        },
        {
          prop: "deviceTypeText",
          label: "设备类型"
        },
        {
          prop: "deviceManufacturerName",
          label: "设备厂商"
        },
        {
          prop: "deviceModelName",
          label: "设备型号"
        },
        {
          prop: "vg",
          label: "额定电压(kV)"
        },
        {
          prop: "ir",
          label: "额定电流(A)"
        },
        {
          prop: "rc",
          label: "额定容量(kVa)"
        },
        {
          prop: "runTime",
          label: "投运日期"
        },
        {
          prop: "bindPlaceName",
          label: "所属场所"
        },
        {
          prop: "bindGaetwayName",
          label: "关联网关"
        }
      ],
      tableData: [],
      total: 0,
      selectionArr: [],
      requestData: {
        deviceType: "",
        searchKey: "",
        pageSize: 10,
        pageNum: 1
      },

      addDataParkHonor2: "smart-detection-probe-add",
      deviceTypeList2: [
        { key: "", label: "全部" },
        {key: 'S0', label: '液位传感器'},
        {key: 'S1', label: '液压传感器'},
        {key: 'S2', label: '温湿度传感器'},
        {key: 'S3', label: '水质传感器'},
        {key: 'S4', label: '电压/电流传感器'},
        {key: 'S5', label: '风速传感器'},
        {key: 'S6', label: '气压传感器'},
        {key: 'S7', label: '高度传感器'},
      ],
      tableHead2: [
        {
          prop: "deviceName",
          label: "设备名称"
        },
        {
          prop: "deviceCode",
          label: "设备编号"
        },
        {
          prop: "deviceTypeText",
          label: "设备类型"
        },
        {
          prop: "deviceManufacturerName",
          label: "设备厂商"
        },
        {
          prop: "deviceModelName",
          label: "设备型号"
        },
        {
          prop: "bindPlaceName",
          label: "所属场所"
        },
        {
          prop: "bindGaetwayName",
          label: "关联网关"
        }
      ],

      addDataParkHonor3: "smart-detection-probe-add2",
      deviceTypeList3: [
        { key: "", label: "全部" },
        {key: 'T0', label: '水浸传感器'},
        {key: 'T1', label: '气体监测传感器'},
      ],
      tableHead3: [
        {
          prop: "deviceName",
          label: "设备名称"
        },
        {
          prop: "deviceCode",
          label: "设备编号"
        },
        {
          prop: "deviceTypeText",
          label: "设备类型"
        },
        {
          prop: "deviceManufacturerName",
          label: "设备厂商"
        },
        {
          prop: "deviceModelName",
          label: "设备型号"
        },
        {
          prop: "bindPlaceName",
          label: "所属场所"
        },
        {
          prop: "bindGaetwayName",
          label: "关联网关"
        }
      ],

      addDataParkHonor4: "smart-detection-probe-add3",
      tableHead4: [
        {
          prop: "deviceName",
          label: "设备名称"
        },
        {
          prop: "deviceCode",
          label: "设备编号"
        },
        {
          prop: "deviceTypeText",
          label: "设备类型"
        },
        {
          prop: "deviceManufacturerName",
          label: "设备厂商"
        },
        {
          prop: "deviceModelName",
          label: "设备型号"
        },
        {
          prop: "bindPlaceName",
          label: "所属场所"
        },
        {
          prop: "bindGaetwayName",
          label: "关联网关"
        },
      ],
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    getPage() {
      let url='';
      if(this.tabName=='first'){
        url=api.getPowerDetectorPage
      }else if (this.tabName=='second'){
        url=api.getStatusDetectorPage
      }else if(this.tabName=='third'){
        url=api.getTouchDetectorPage
      }else if(this.tabName=='fourth'){
        url=api.getPumpDetectorPage
      }
      this.$axios
        .post(url, this.requestData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map(v => {
              v.code = v.deviceCode;
              if(v.deviceType=='S0'){
                v.deviceTypeText='液位传感器'
              }else if(v.deviceType=='S1'){
                v.deviceTypeText='液压传感器'
              }else if(v.deviceType=='S2'){
                v.deviceTypeText='温湿度传感器'
              }else if(v.deviceType=='S3'){
                v.deviceTypeText='水质传感器'
              }else if(v.deviceType=='S4'){
                v.deviceTypeText='电压/电流传感器'
              }else if(v.deviceType=='S5'){
                v.deviceTypeText='风速传感器'
              }else if(v.deviceType=='S6'){
                v.deviceTypeText='气压传感器'
              }else if(v.deviceType=='S7'){
                v.deviceTypeText='高度传感器'
              }else if(v.deviceType=='T0'){
                v.deviceTypeText='水浸传感器'
              }else if(v.deviceType=='T1'){
                v.deviceTypeText='气体监测传感器'
              }else if(v.deviceType=='P0'){
                v.deviceTypeText='状态采集器'
              }else if(v.deviceType=='P1'){
                v.deviceTypeText='电压采集器'
              }else if(v.deviceType=='P2'){
                v.deviceTypeText='温度采集器'
              }else if(v.deviceType=='B0'){
                v.deviceTypeText='水泵设备'
              }
            });
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },
    search(v) {
      this.requestData.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.requestData.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    goToModifyPage(code) {
      let tabName='';
      tabName=this.tabName
      this.$router.push({
        name: "smart-detection-probe-modify",
        params:{
          code,
          tabName
        }
      });
    },

    goToModifyPage2(code) {
      this.$router.push({
        path: `smart_detection_power_distribution_cabinet_modify/${code}`,
      });
    },

    deleteLine(code) {
      let url="";
      if(this.tabName=='first'){
        url=api.delPowerDetector
      }else if (this.tabName=='second'){
        url=api.delStatusDetector
      }else if(this.tabName=='third'){
        url=api.delTouchDetector
      }else if(this.tabName=='fourth'){
        url=api.delPumpDetector
      }
      this.$axios
        .post(url, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.selectionArr = [];
            this.getPage();
          }
        })
        .catch(errorHandler("删除失败"));
    }
  },
  watch: {
    centEndTime(val) {
      this.getPage();
    },
    tabName(){
      this.getPage();
    }
  }
};
</script>

<style scoped>
.form-line {
  width: 420px;
  margin: 20px auto;
  display: flex;
  justify-content: flex-start;
}
.form-line > div {
  margin-right: 20px;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 122px;
  line-height: 32px;
  text-align: right;
}
.red {
  color: red;
}
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/view/SmartDetection/SmartDetectionPowerDistributionCabinet/SmartDetectionPowerDistributionCabinetManage.vue